import { defaultCompData } from '../constants';
import type {
  LoginSocialBarData,
  LoggedInTextState,
} from '../LoginSocialBar.types';
import { AvatarIcon, Layout } from '../LoginSocialBar.types';

type GetSanitizedCommonCompData = (compData: LoginSocialBarData) => {
  loggedInMember: Layout;
  loggedOutMember: Layout;
  loggedInAvatarIcon: AvatarIcon;
  loggedOutAvatarIcon: AvatarIcon;
  loggedInTextState: LoggedInTextState;
  loggedInCustomAvatar: string;
  loggedOutCustomAvatar: string;
  showLoggedInText: boolean;
};

// TODO: after enabling CSS PB support, leave only params
// that are not customizable per breakpoint
export const getSanitizedCommonCompData: GetSanitizedCommonCompData =
  compData => {
    const splitAndDeprecateMemberInitials =
      compData.loggedInMember === Layout.MemberInitials;

    const loggedInMember = splitAndDeprecateMemberInitials
      ? Layout.AvatarOnly
      : compData.loggedInMember ?? defaultCompData.loggedInMember;

    const fallbackLoggedOutDisplayMode =
      compData.loggedInMember === Layout.TextOnly
        ? Layout.TextOnly
        : defaultCompData.loggedOutMember;

    const loggedOutMember =
      compData.loggedOutMember ?? fallbackLoggedOutDisplayMode;

    const loggedInAvatarIcon = splitAndDeprecateMemberInitials
      ? AvatarIcon.Initials
      : compData.loggedInAvatarIcon ?? defaultCompData.loggedInAvatarIcon;

    const loggedOutAvatarIcon =
      compData.loggedOutAvatarIcon ?? loggedInAvatarIcon;

    const loggedInTextState =
      compData.loggedInTextState ?? defaultCompData.loggedInTextState;

    const loggedInCustomAvatar =
      compData.loggedInCustomAvatar ?? defaultCompData.loggedInCustomAvatar;

    const loggedOutCustomAvatar =
      compData.loggedOutCustomAvatar ?? defaultCompData.loggedOutCustomAvatar;

    const showLoggedInText =
      compData.showLoggedInText ?? defaultCompData.showLoggedInText;

    return {
      loggedInMember,
      loggedOutMember,
      loggedInAvatarIcon,
      loggedOutAvatarIcon,
      loggedInTextState,
      loggedInCustomAvatar,
      loggedOutCustomAvatar,
      showLoggedInText,
    };
  };
